<template lang="pug">
  .blog-posts.xs-12
    .posts-spinner(v-if="searching")
      MrSpinner
    
    template(v-if="!searching")
      .hero-container.xs-12(v-if="heroPost")
        .single-post.xs-12
          a.blog-hero.xs-12(:href="heroPost.uri")
            .hero-image.xs-12.sm-6.md-8
              .a-box-xs-10x9.a-box-md-2x1
                .a-box-content
                  ResponsiveImage(:mediaObj='heroPost.image' xsAspectKey="10x9" mdAspectKey="2x1")
            .hero-description.xs-12.sm-6.md-4.text-left
              .sm-v-center.md-v-center.lg-v-center
                p.f-primary.brand-color-1.xs-f-medium.sm-f-large.lg-f-xlarge.max-at-tweak.pb-25m {{heroPost.title}}
                p.xs-f-small.max-at-tweak {{heroPost.shortDescription}}

      .post-container.xs-12(v-if="posts")
        .single-post.xs-12.sm-6.md-4(v-for="post in posts")
          .a-box-sm-2x3
            .sm-a-box-content
              a.blog-post.xs-12(:href="post.uri")
                .a-box-xs-10x9
                  .a-box-content
                    ResponsiveImage(:mediaObj='post.image' xsAspectKey="10x9").block
                
                .xs-12.text-left.pt-75m
                  p.f-primary.brand-color-1.xs-f-medium.md-f-xmedium.max-at-tweak.pb-25m {{post.title}}
                  p.xs-f-small.max-at-tweak {{post.shortDescription}}

      .pagination-wrap.xs-12
        .xs-6.pl-75m
          router-link.page-prev.semi-bold.brand-color-1.xs-f-medium.md-f-xmedium.max-at-tweak(v-if="pagination.prevSize" :to="pageRouteObject(page -1)") &lt; Previous {{pagination.prevSize}} Posts
        
        .xs-6.text-right.pr-75m
          router-link.page-next.semi-bold.brand-color-1.xs-f-medium.md-f-xmedium.max-at-tweak(v-if="pagination.nextSize" :to="pageRouteObject(page + 1)") Next {{pagination.nextSize}} Posts &gt;

</template>

<script>
  import vueCmsSvc from '@services/vueCmsSvc';
  import ResponsiveImage from '@components/ResponsiveImage';
  import MrSpinner  from "@components/MrSpinner";

  export default {
    name: "BlogPosts",

    components: {
      ResponsiveImage,
      MrSpinner,
    },

    props: {
      noHero: {
        type: Boolean
      },
      pageSize: {
        type: Number,
        default: 6
      },
      pageOneSize: {
        type: Number,
        default: 7
      },
      initialPage: {
        type: Number,
        default: 1
      },
      initialPagination: {
        type: Object,
        default: null,
      },
      initialPosts: {
        type: Array,
        default() {
          return [];
        },
      },
      searchType: {
        type: String,
        default: '',
      },
      search: {
        type: String,
        default: '',
      }
    },

    data() {
      return {
        asyncPosts: null,
        searching: false,
      };
    },

    computed: {
      page() {
        return +this.$route.query.p || this.initialPage;
      },

      hits() {
        if (this.asyncPosts && this.asyncPosts.hits && this.asyncPosts.hits.length) {
          return this.asyncPosts.hits;
        } else {
          return this.initialPosts;
        }
      },

      heroPost() {
        if (!this.noHero && this.page == 1 && this.hits && this.hits.length) {
          return this.hits[0];
        } else {
          return null;
        }
      },

      posts() {
        if (this.hits && this.hits.length) {
          if (this.heroPost) {
            // don't include first post in posts when there is a heroPost
            return this.hits.slice(1, this.hits.length);
          } else {
            return this.hits;
          }
        } else {
          return null;
        }
      },

      pagination() {
        if (this.initialPage == this.page && this.initialPagination) {
          return this.initialPagination;
        } else if (this.asyncPosts && this.asyncPosts.pagination) {
          return this.asyncPosts.pagination;
        }
        return {};
      }
    },

    watch: {
      initialPage: {
        immediate: true,
        handler: 'retrievePosts'
      },
      page: {
        immediate: true,
        handler: 'retrievePosts'
      },
      pageSize: {
        immediate: true,
        handler: 'retrievePosts'
      },
      pageOneSize: {
        immediate: true,
        handler: 'retrievePosts'
      },
      search: {
        immediate: true,
        handler: 'retrievePosts'
      },
      searchType: {
        immediate: true,
        handler: 'retrievePosts'
      },
    },

    methods: {
      retrievePosts() {
        this.searching = true;
        return vueCmsSvc.searchBlogContent({
          p: this.page,
          s: this.pageSize,
          s1: this.pageOneSize,
          searchVal: this.search || '',
          searchType: this.searchType || 'all'
        }).then(res => {
          this.asyncPosts = res.data;
          this.searching = false;
        }).catch(() => this.searching = false);
      },

      pageRouteObject(page) {
        return {
          query: {
            ...this.$route.query,
            p: page,
          },
        };
      },
    },
  };
</script>

<style scoped lang="stylus">
  .blog-posts
    .posts-spinner
      height 20em
      display flex
      align-items center
      justify-content center

    .post-container
      .single-post
        padding-left 0.75em
        padding-right 0.75em
      
    .hero-container
    .post-container
      .single-post
        padding-bottom 1.5em
        
        .blog-hero
        .blog-post
          color text-color-2
          
        @media mq-mobile
          .hero-description
            padding-top 0.75em
            
        @media mq-tablet-plus
          .hero-image
            padding-right 0.75em
            
          .hero-description
            padding-left 0.75em
            position absolute
            top 0
            right 0
            bottom 0

</style>